<template>
  <div>
    <v-icon
      class="text-center"
      small
      color="green"
      @click="openEdit()"
    >
      mdi-whatsapp
    </v-icon>
    <v-dialog
      v-model="dialog"
      max-width="480"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center headline">
          Select Group
          <v-btn
            color="green"
            class="white--text"
            @click="create()"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Create Group
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-row class="py-3">
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedGroup"
                :items="chatGroups"
                chips
                label="Select Group"
                item-text="chat_name"
                item-value="chat_id"
                return-object
                clearable
                :menu-props="{ maxWidth: '380' }"
                outlined
                dense
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    close
                    class="ma-1"
                    small
                    @click:close="remove(item)"
                  >
                    <v-avatar left>
                      <v-img :src="item.chat_image" />
                    </v-avatar>
                    {{ item.chat_name }}
                  </v-chip>
                </template>

                <template v-slot:item="{ item }">
                  <div style="width: 100%;">
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-img :src="item.chat_image" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.chat_name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.chat_id }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider style="margin: 0 14px;" />
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            class="white--text"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green"
            class="white--text"
            @click="attachGroup()"
          >
            Attach
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createGroup"
      max-width="480"
    >
      <v-card height="225">
        <v-card-title class="d-flex justify-space-between align-center headline">
          Create Group
        </v-card-title>
        <v-card-text class="pa-4">
          <v-form
            ref="createGroup"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-text-field
                v-model="chat.group_name"
                label="Group Name*"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight: 400; margin-right: 4px">*indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            color="error"
            class="white--text"
            @click="createGroup = false"
          >
            Close
          </v-btn>
          <v-btn
            color="success"
            class="white--text"
            :loading="loader"
            @click.native="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { failure } from "@/mixins/common";
export default {
  mixins: [failure],
  props: {
    chatGroups: {
      type: Array,
      required: true,
      default: () => []
    },
    stores: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      dialog: false,
      createGroup: false,
      selectedGroup: null,
      isValid: false,
      chat: {
        group_name: ""
      },
      rules: [v => !!v || "Field is required"]
    };
  },
  methods: {
    openEdit(){
      this.dialog = true;
      this.$emit("getChatGroups");
    },
    remove() {
      this.selectedGroup = null;
    },
    save() {
      if (!this.$refs.createGroup.validate()) {
        return;
      }
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/periscope/chatGroups`;
      this.$http.post(url, this.chat).then(
        (res) => {
          this.loader = false;
          this.createGroup = false;
          this.$emit("getChatGroups");
          this.handleSuccess(res);
        },
        failure => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    attachGroup() {
      if (!this.selectedGroup) {
        return;
      }
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/stores/${this.stores.id}/updateStoreWhatsApp`;
      this.$http.put(url, this.selectedGroup).then(
        (res) => {
          this.loader = false;
          this.dialog = false;
          this.$emit("refresh");
          this.handleSuccess(res);
        },
        (failure) => {
          this.handleFailure(failure);
          this.loader = false;
        }
      );

    },
    create() {
      this.createGroup = true;
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    }
  }
};
</script>